import { getUuid } from '~/js/zeta/getUuid'
const QUERY_ZETA_QA = '.js-zetaQa'
const ID_ZETA_QA = 'ZVCQA'

document.addEventListener('DOMContentLoaded', async () => {
  const elementZetaQa = document.querySelector(QUERY_ZETA_QA)
  if (!elementZetaQa) return

  const uuid = await getUuid()
  elementZetaQa.dataset.userId = uuid
  elementZetaQa.id = ID_ZETA_QA
  window.zvRenderCustomerqaList()
})
